<template lang="pug">
.content-wrap
  .content-top
    .con
      .resbox
        .resbox-top.nopad 
          .resbox-info
            .bban
              //- img(src='/new/img/refer.jpg')
              img(src='/new/img/referral.gif')
            .ccon(v-if="isLoggedIn")
              br
              small Share your referral link:
              .ffi  {{getReferralcode}}    
                i.fas.fa-copy
              .btn-copy.pointer(@click="copyClipboard") Copy Link
            .bban 
              img(src="/new/img/chart.png")
        .resbox-con.vip-refer
          .table-responsive
            table.vip-table.table(cellpadding='0' cellspacing='0')
              thead
                tr
                  th &nbsp;
                  th Levels
                  th
                    span Daily Referral Promote Commission
              tbody
                tr
                  td(rowspan='4')
                    img(src='/new/img/vip/bronze.png')
                  td Bronze level 1
                  td 0.50%
                tr
                  td Bronze level 2
                  td 0.50%
                tr
                  td Bronze level 3
                  td 0.50%
                tr
                  td Bronze level 4
                  td 0.50%
                tr.even
                  td(rowspan='4')
                    img(src='/new/img/vip/silver.png')
                  td Silver level 1
                  td 0.50%
                tr.even
                  td Silver level 2
                  td 0.50%
                tr.even
                  td Silver level 3
                  td 0.50%
                tr.even
                  td Silver level 4
                  td 0.50%
                tr
                  td(rowspan='4')
                    img(src='/new/img/vip/gold.png')
                  td Gold level 1
                  td 0.50%
                tr
                  td Gold level 2
                  td 0.50%
                tr
                  td Gold level 3
                  td 0.50%
                tr
                  td Gold level 4
                  td 0.50%
                tr.even
                  td(rowspan='4')
                    img(src='/new/img/vip/platinium.png')
                  td Platinium level 1
                  td 0.50%
                tr.even
                  td Platinium level 2
                  td 0.55%
                tr.even
                  td Platinium level 3
                  td 0.60%
                tr.even
                  td Platinium level 4
                  td 0.65%
                tr
                  td(rowspan='4')
                    img(src='/new/img/vip/diamond.png')
                  td Diamond level 1
                  td 0.85%
                tr
                  td Diamond level 2
                  td 0.90%
                tr
                  td Diamond level 3
                  td 0.95%
                tr
                  td Diamond level 4
                  td 1%
                tr.even
                  td
                    img(src='/new/img/vip/vip-epic.png')
                  td EPIC VIP
                  td 1.2%
          .v-info
            p Meet the promotion requirements to automatically receive real-time payouts
              br
              span.yellow Excluding Jackpot Fishing &amp; HASH GAME from JILI Games &amp; Live Casino
            | 
            | 
            | How to calculate:
            .v-frame
              span.v-remark Example
              p
                span.orange Bronze Level 1
                | : You will receive 0.50% of the bet amount from members at this level.
                br
                | For instance, if a member at this level bet ₱100,000 yesterday, you will receive ₱500.
              p
                span.cyan Platinum Level 2
                | : You will receive 0.55% of the bet amount from members at this level.
                br
                | For instance, if a member at this level bet ₱200,000 yesterday, you will receive ₱1,100.
              p
                span.violet EPIC VIP
                | : You will receive 1.2% of the bet amount from members at this level.
                br
                | For instance, if a member at this level bet ₱200,000 yesterday, you will receive ₱2,400.
            br
            | How can I refer someone?
            .v-frame
              p
                | Step:
                span.green Login
                i.fa-solid.fa-arrow-right
                span.violet Referral
                br
                br
                | Share your referral code with the person you would like to refer.
            br
            p Enjoy your Bonus Reward based on your referred members' turnover.
              br
              | The more friends you invite, the more commission you will earn every day!
    footerInfo(:target="'/referral'")
          //- .resbox-con
            .resbox-tabs
              ul.nav.nav-tabs(role='tablist')
                li.nav-item(@click="changeTab(1)")
                  button.nav-link.active(data-bs-toggle='tab' data-bs-target='#downline-turnover') {{$t('ui.turnover_downline')}}
                li.nav-item(@click="changeTab(2)")
                  button.nav-link(data-bs-toggle='tab' data-bs-target='#daily-game-rebate') {{$t('ui.daily_rebate')}}
                //- li.nav-item(role='presentation' @click="changeTab(1)")
                //- 	button#dt-tab.nav-link.active(data-bs-toggle='tab' data-bs-target='#dt' type='button' role='tab' aria-controls='dt' aria-selected='true') {{$t('ui.turnover_downline')}}
                //- li.nav-item(role='presentation' @click="changeTab(2)")
                //- 	button#dgr-tab.nav-link(data-bs-toggle='tab' data-bs-target='#dgr' type='button' role='tab' aria-controls='dgr' aria-selected='false') {{$t('ui.daily_rebate')}}
              .tab-content.p-0
                downLine(v-if="selectedTab === 1" @showDownlineTurnover="showDownlineTurnover" ref='downLine')
                self(v-if="selectedTab === 2")
                template(v-if="showDownline")
                  .d-flex.justify-content-end.me-3.mb-3
                    .btn-sub.s2(@click="hideDownline") back
            //- .table-responsive
              table.restable.table(cellpadding='0' cellspacing='0')
                thead
                  tr
                    th No.
                    th Username
                    th.text-end Turnover Amount
                tbody
                  tr
                    td.text-center(colspan='3') No Record Found
</template>
<script>
// import self from '@/component/referral/_self.vue'
// import downLine from '@/component/referral/_downLine.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  components:{
    footerInfo
    // self,
    // downLine,
  },
  data(){
    return{
      // selectedTab: 1,
      // showDownline: false,
      // rebateList:[]
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getReferralcode(){
      return this.$store.state.user.account.referral_code || ""
    },
    // whatsappLink(){
    //   return `whatsapp://send?text=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    // },
    // fbLink(){
    //   return `https://www.facebook.com/sharer/sharer.php?u=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    // },
    // tgLink(){
    //   return `tg://msg_url?url=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    // }
  },
  // watch:{
  //   sessionToken(newState, oldState){
  //     var vm = this
  //     if(newState === '' || newState === undefined){
  //       vm.$router.push("/").catch(err => {});
  //     }
  //   }
  // },
  mounted(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/referral`);
    window.scroll(0,0)
    // this.getRebateChart()
  },
  methods:{
    openModal(target){
      $(target).modal('show')
    },
    copyClipboard(){
      if(!this.sessionToken) return;

      const g = document.createElement('div');
      g.id = "urlLink";
      g.innerHTML = window.location.protocol + "//" +window.location.hostname +"?ref="+ this.getReferralcode
      document.body.appendChild(g);
      var range = document.createRange();
      range.selectNode(document.getElementById("urlLink"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      document.body.removeChild(g);
      this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.copy_clipboard"), "success", this)
    },
    // changeTab(option){
    //   if(option === this.selectedTab){
    //     return;
    //   }else{
    //     this.selectedTab = option
    //   }
    //   this.showDownline = false
    // },
    // showDownlineTurnover(e){
    //   this.downlineId = e
    //   this.showDownline = true
    // },
    // hideDownline(){
    //   this.showDownline = false
    //   this.$refs.downLine.hideDownline()
    // },
    // getRebateChart(){
    //   if (this.sessionToken) {
    //     var vm = this
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     this.$store
    //       .dispatch("user/getRebateChart", { account_id, auth_token})
    //       .then(response => {
    //         if (response.success == true) {
    //           this.rebateList = response.data
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
    //     return
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.nav-item{
  width: 50%;
}
.btn-sub{
  margin-left: 10px;
  padding: 5px;
  color: #5c4180;
}
.share-button{
  margin-right: 10px
}
.social{
  text-decoration: none;
  color: #ffffff;
  margin-bottom: 10px;
  &:hover{
    color:#FFC000;
  }
  img{
    margin-right: 5px;
  }
}
.custom-display{
  display: none;
  @media(min-width: 768px){
    display: flex;
  }
}
.custom-p10{
  padding-left: 10px
}
.resbox-tabs .tab-content .tab-pane {
  background-color: #280056; 
}
</style>
  